<!--航空报表设置-->
<template>
  <el-form ref="form" :model="form" label-width="80px" size="mini">
    <div class="row-wrap" style="padding:0px 30px;">
      <el-table :data="hangkongs" ref="hangkongRef" row-key="key" border style="width: 100%" size="mini" highlight-current-row stripe>
        <el-table-column label="航空资料">
          <el-table-column type="selection" width="80"></el-table-column>
          <el-table-column type="index" min-width="100"></el-table-column>
          <el-table-column prop="key" min-width="120" :label="msg('字段KEY')" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" min-width="120" :label="msg('字段NAME')" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name1" min-width="120" :label="msg('字段显示名')" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input v-model="scope.row.name1" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="value" min-width="120" :label="msg('固定值')" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input v-model="scope.row.value" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="排序" min-width="130">
            <template slot-scope="scope">
              <i class="el-icon-rank drag-handle" draggable="true" :title="msg('按住拖动排序')"></i>
              <el-link @click="handleMoveUp(hangkongs, scope.$index)" icon="el-icon-top"></el-link>
              <el-link @click="handleMoveDown(hangkongs, scope.$index)" style="margin-left:5px;"
                       icon="el-icon-bottom"></el-link>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div style="text-align:center; margin-top: 15px; margin-bottom:15px;">
      <el-button type="primary" size="mini" @click="update"><i class="el-icon-check"></i><span>{{ msg('确定') }}</span>
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "UserSettingReportHangkong",
  data() {
    return {
      xgroup: 'HANGKONG_REPORT',
      form: {
        hks: [],
      },
      hangkongs:[
        {
          key:'exp_pkg_code',
          name:'清關條碼',
          name1:'清關條碼',
          value:'',
          show:null,
        },
        {
          key:'code',
          name:'提單號碼',
          name1:'提單號碼',
          value:'',
          show:null,
        },
        {
          key:'expPageCode',
          name:'面單碼',
          name1:'面單碼',
          value:'',
          show:null,
        },
        {
          key:'expCode',
          name:'查詢碼',
          name1:'查詢碼',
          value:'',
          show:null,
        },
        {
          key:'product_name',
          name:'品名',
          name1:'品名',
          value:'',
          show:null,
        },
        {
          key:'pkg_qty',
          name:'袋數',
          name1:'袋數',
          value:'',
          show:null,
        },
        {
          key:'weight_pkg',
          name:'袋重',
          name1:'袋重',
          value:'',
          show:null,
        },
        {
          key:'count',
          name:'數量',
          name1:'數量',
          value:'',
          show:null,
        },
        {
          key:'weight_exp',
          name:'重量',
          name1:'重量',
          value:'',
          show:null,
        },
        {
          key:'remark',
          name:'備註',
          name1:'備註',
          value:'',
          show:null,
        },
        {
          key:'order_origin',
          name:'订单来源',
          name1:'订单来源',
          value:'',
          show:null,
        },
        {
          key:'exp_out_type',
          name:'出货方式',
          name1:'出货方式',
          value:'',
          show:null,
        },
        {
          key:'exp_batch',
          name:'批次',
          name1:'批次',
          value:'',
          show:null,
        },
        {
          key:'remark1',
          name:'',
          name1:'',
          value:'',
          show:null,
        },
        {
          key:'remark2',
          name:'',
          name1:'',
          value:'',
          show:null,
        },
      ],
      dragBound: false, //拖动事件是否已绑定
      dragFromIndex: null, //拖动中的行下标
    }
  },
  mounted() {
    this.getSettings();
    this.$nextTick(() => {
      this.initRowDrag();
    });
  },
  methods: {
    getSettings() {
      var _this = this;
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data) {
      var _this = this;
      _this.form.hks = [];

      let hangkongReports = data;//航空报表设置

      //航空报表
      if (hangkongReports.length > 0) {
        hangkongReports.forEach(a => {
          if (a.xvalue) {
            let hk = {
              id: a.id ? a.id : null,
              xkey: _this.xgroup,
              owner: a.owner ? a.owner : null,
              xgroup: _this.xgroup,
              xvalue: a.xvalue,
              xtype: 1
            }
            _this.form.hks.push(hk);
          }
        })
        let hks = hangkongReports[0];
        let hk = JSON.parse(hks.xvalue);
        if (hk && hk.length > 0) {
          _this.hangkongs.splice(0, _this.hangkongs.length);
          hk.forEach(e => {
            _this.hangkongs.push(
                {
                  key: e.key,
                  name: e.name,
                  name1: e.name1,
                  value: e.value,
                  show: e.show,
                },
            )
          })
          _this.hangkongs.forEach(e => {
            if (e.show) {
              _this.$refs.hangkongRef.toggleRowSelection(e, true);
            }
          })
        }
      } else {
        _this.form.hks.push({
          id: null,
          xkey: _this.xgroup,
          owner: null,
          xgroup: _this.xgroup,
          xvalue: 0,
          xtype: 0
        })
        if (this.hasPermission('stock:downloadHangkong')) {
          _this.hangkongs.forEach(e => {
            _this.$refs.hangkongRef.toggleRowSelection(e);
          })
        }
      }
    },
    handleMoveUp(datas, index){
      if(index == 0){
        return;
      }
      let row = datas[index];
      let prevRow = datas[index-1];
      //触发数组变动
      datas.splice(index, 1, prevRow);
      datas.splice(index - 1, 1, row);
    },
    handleMoveDown(datas, index){
      if(index >= datas.length-1){
        return;
      }
      let row = datas[index];
      let lastRow = datas[index+1];
      //触发数组变动
      datas.splice(index, 1, lastRow);
      datas.splice(index+1, 1, row);
    },
    //绑定鼠标拖动排序：事件委托在 tbody 上，行数据重排后依然有效
    initRowDrag() {
      if (this.dragBound) {
        return;
      }
      let tableEl = this.$refs.hangkongRef && this.$refs.hangkongRef.$el;
      if (!tableEl) {
        return;
      }
      let tbody = tableEl.querySelector('.el-table__body-wrapper tbody');
      if (!tbody) {
        return;
      }
      this.dragBound = true;
      var _this = this;
      let dragRowEl = null;

      //开始拖动：记录起始行，并把整行作为跟随鼠标的拖动影像
      tbody.addEventListener('dragstart', function (e) {
        let tr = e.target.closest ? e.target.closest('tr') : null;
        if (!tr) {
          e.preventDefault();
          return;
        }
        dragRowEl = tr;
        _this.dragFromIndex = Array.prototype.indexOf.call(tbody.children, tr);
        tr.classList.add('row-dragging');
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', '');
        if (e.dataTransfer.setDragImage) {
          e.dataTransfer.setDragImage(tr, 20, 20);
        }
      });

      //拖动经过其它行：实时交换位置，所见即所得
      tbody.addEventListener('dragover', function (e) {
        if (_this.dragFromIndex === null) {
          return;
        }
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        let tr = e.target.closest ? e.target.closest('tr') : null;
        if (!tr || tr === dragRowEl) {
          return;
        }
        let toIndex = Array.prototype.indexOf.call(tbody.children, tr);
        if (toIndex < 0) {
          return;
        }
        _this.moveRow(_this.dragFromIndex, toIndex);
        _this.dragFromIndex = toIndex;
      });

      tbody.addEventListener('drop', function (e) {
        e.preventDefault();
      });

      //拖动结束：清理拖动状态
      tbody.addEventListener('dragend', function () {
        if (dragRowEl) {
          dragRowEl.classList.remove('row-dragging');
        }
        dragRowEl = null;
        _this.dragFromIndex = null;
      });
    },
    //把第 from 行移动到第 to 行，直接改动数组即可让表格重新渲染
    moveRow(from, to) {
      if (from === to || from < 0 || to < 0 || from >= this.hangkongs.length || to >= this.hangkongs.length) {
        return;
      }
      //触发数组变动
      let row = this.hangkongs.splice(from, 1)[0];
      this.hangkongs.splice(to, 0, row);
    },
    update() {
      let datas = [];
      //构建航空报表
      if (this.hasPermission('stock:downloadHangkong')) {
        let hk = this.form.hks[0];
        let hangkongs = this.$refs.hangkongRef.selection;
        if (hangkongs.length == 0) {
          this.$message(this.msg('航空字段必须选中一个'));
          return;
        }
        this.hangkongs.forEach(e => {
          e.show = false;
          hangkongs.forEach(f => {
            if (e.key == f.key) {
              e.show = true;
            }
          })
        })
        let hkvalue = JSON.stringify(this.hangkongs);
        datas.push({
          id: hk.id ? hk.id : null,
          xkey: this.xgroup,
          owner: hk.owner ? hk.owner : null,
          xgroup: this.xgroup,
          xvalue: hkvalue,
          xtype: 1
        });

        var _this = this;
        _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + this.xgroup, datas).then((result) => {
          _this.$message(result.msg)
        });
      }
    }
  }
}
</script>

<style scoped>
.drag-handle {
  cursor: move;
  margin-right: 8px;
  color: #909399;
}
.drag-handle:hover {
  color: #409EFF;
}
/* 拖动中的行由 el-table 生成，使用深度选择器覆盖 scoped 样式 */
::v-deep .row-dragging {
  opacity: 0.6;
  background-color: #f5f7fa !important;
}
</style>
